import { render, staticRenderFns } from "./TcKeywordsProposalTable.vue?vue&type=template&id=a8421424&"
import script from "./TcKeywordsProposalTable.vue?vue&type=script&lang=js&"
export * from "./TcKeywordsProposalTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports